// extracted by mini-css-extract-plugin
module.exports = {"container":"PlanFact_container__2rviI","slider":"PlanFact_slider__2E5Ke","switch":"PlanFact_switch__3PtuZ","right":"PlanFact_right__2JCi8","header":"PlanFact_header__RmbUF"};